module.exports = __webpack_public_path__ + "static/media/PublicatieoverzichtArtikelgemist.68bb05d9.pdf";